import { z } from 'zod';
import type { CareCallReason } from './care-call-reason';
import type { RoutableCareCallType } from './care-call-types';

/**
 * Why a member is booking, when it is not their next derived call. Members
 * never name a call type; a purpose is the closed set of booking paths the
 * server routes to a fixed call type and reason, each behind its own
 * server-side entitlement check.
 */
export const CARE_BOOKING_PURPOSE = ['hdhp'] as const;
export type CareBookingPurpose = (typeof CARE_BOOKING_PURPOSE)[number];
export const careBookingPurposeSchema = z.enum(CARE_BOOKING_PURPOSE);

const PURPOSE_ROUTES: Record<
  CareBookingPurpose,
  { callType: RoutableCareCallType; callReason: CareCallReason }
> = {
  // The member ops call is free to the member: billing keeps member_support
  // out of fee-for-service, which a dedicated call type would not get.
  hdhp: { callType: 'member_support', callReason: 'hdhp' },
};

export function bookingPurposeCallType(purpose: CareBookingPurpose): RoutableCareCallType {
  return PURPOSE_ROUTES[purpose].callType;
}

export function bookingPurposeCallReason(purpose: CareBookingPurpose): CareCallReason {
  return PURPOSE_ROUTES[purpose].callReason;
}
